import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomLoader from "../../../../../Components/CustomLoader";
import ErrorMessage from "../../../../../Components/ErrorMessage";
import EliminarRedSocial from "./EliminarCampaign";
import EliminarCampaign from "../Actions/NuevaCampaign";
import {
  formatoFechaCorta,
  formatoMexico,
  getBicolorTable,
} from "../../../../../Config/reuserFunctions";
import { useTheme } from "@mui/material";

export default function RedesSocialesTable({ campaignQuery }) {
  const { loading, data, error, refetch } = campaignQuery;
  const theme = useTheme();

  if (loading) return <CustomLoader />;
  if (error) return <ErrorMessage />;

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden" }}>
      <TableContainer
        sx={{
          transition: "width .3s",
          height: { xs: `calc(100vh - 190px)`, sm: `calc(100vh - 120px)` },
          overflowX: "scroll",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID Campaña</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Inicio</TableCell>
              <TableCell>Fin</TableCell>
              <TableCell>Red social</TableCell>
              <TableCell>Presupuesto</TableCell>
              <TableCell>Fecha registro</TableCell>
              <TableCell padding="checkbox" />
              <TableCell padding="checkbox" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.obtenerCampaign.map((data, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={`red-${data._id}`}
                  style={getBicolorTable(theme, index)}
                >
                  <TableCell>{data.idExterno}</TableCell>
                  <TableCell>{data.nombre}</TableCell>
                  <TableCell>{formatoFechaCorta(data.fechaInicio)}</TableCell>
                  <TableCell>{formatoFechaCorta(data.fechaFin)}</TableCell>
                  <TableCell>{data.redSocial}</TableCell>
                  <TableCell>${formatoMexico(data.presupuesto)}</TableCell>
                  <TableCell>{formatoFechaCorta(data.fechaRegistro)}</TableCell>
                  <TableCell padding="checkbox">
                    <EliminarCampaign
                      edit={true}
                      data={data}
                      refetch={refetch}
                    />
                  </TableCell>
                  <TableCell padding="checkbox">
                    <EliminarRedSocial data={data} refetch={refetch} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
